const API_URL = "https://api.modernliving.ae/api/";

export default API_URL;